import { connect } from 'react-redux';
import ToggleSection from '../../../../../../common/components/ToggleSection/ToggleSection';
import { changeBPTScopeAxaEvolution } from '../../data/actions';
import { getBptPreferenceAnalysisContentScopeSelector } from '../../data/selectors';

const mapStateToProps = state => ({
    toggleLabels: {
        left: 'Axa',
        right: 'Evolution / competition',
        imageAlt: 'BPT Toggle Button',
    },
    contentScope: getBptPreferenceAnalysisContentScopeSelector(state),
});

const mapDispatchToProps = {
    changeScope: changeBPTScopeAxaEvolution,
};

const ToggleSectionContainer = connect(mapStateToProps, mapDispatchToProps)(ToggleSection);

export default ToggleSectionContainer;
